import { invalidateTracesList, traceListQuery, traceQuery } from "@common/api"
import { createFileRoute, redirect } from "@tanstack/react-router"
import TracePage from "@/routes/_layout/agent/-components/index"

const agentRecentTracesQuery = traceListQuery({
  skip: 0,
  limit: 20,
  order_by: "created_at",
  order_direction: "desc",
})

export const Route = createFileRoute("/_layout/agent/")({
  staticData: { breadcrumb: "Home" },
  component: TracePage,

  // Landing on the agent home with a from_trace_id means "continue this session":
  // open it as the full-page trace. Drop the param either way (silently if no access).
  beforeLoad: async ({
    context: { queryClient },
    search: { from_trace_id },
  }) => {
    if (from_trace_id) {
      try {
        await queryClient.ensureQueryData(traceQuery({ id: from_trace_id }))
      } catch {
        throw redirect({ to: "/agent", search: {} })
      }
      throw redirect({ to: "/agent/$id", params: { id: from_trace_id } })
    }

    await invalidateTracesList(queryClient, { refetchType: "active" })
    await queryClient.fetchQuery(agentRecentTracesQuery)
  },
})
